module.exports = __webpack_public_path__ + "img/38293d1.jpg";